function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.014 2.526)",
  id: "layer1",
  fillOpacity: 1,
  stroke: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, /*#__PURE__*/React.createElement("rect", {
  ry: 1.462,
  rx: 1.462,
  y: -2.526,
  x: 4.014,
  height: 18.521,
  width: 18.521,
  id: "rect4481",
  display: "inline",
  fill: "#4F5784",
  strokeWidth: 0.049
}), /*#__PURE__*/React.createElement("path", {
  id: "path4429",
  d: "M9.75 2.025l1.206 2.09-4.719 8.176H18.09l-1.207-2.092 4.72-8.174zm3.73 2.281h4.171l-2.085 3.612zm-1.317 2.282l3.293 5.702H8.871z",
  fill: "#273540",
  strokeWidth: 0.103,
  strokeDashoffset: 0
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.008 2.025l1.207 2.091-4.719 8.175H17.35L16.142 10.2l4.72-8.174zm3.731 2.281h4.171l-2.085 3.612zm-1.316 2.282l3.292 5.703H8.13z",
  id: "path4424",
  fill: "#f9f9f9",
  strokeWidth: 0.103,
  strokeDashoffset: 0
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2537",
    viewBox: "0 0 18.521 18.521",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f1253bd2.svg";
export { ForwardRef as ReactComponent };